<template><div /></template>

<script>
export default {
  name: 'Terms',
}
</script>

<style scoped></style>
